
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component
export default class TheBreadcrumbs extends Vue {
  @Prop() title!: string
  @Prop({ default: () => [] }) folders!: any[]
}
